import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/App.css';

import App from './App';

// Amplify configuration
import { Amplify } from 'aws-amplify';

// Try to import aws-exports, with error handling
let awsConfig;
try {
  awsConfig = require('./aws-exports').default;
} catch (error) {
  console.error('Could not load AWS exports - using fallback configuration');
  // Fallback configuration - update with your actual values
  awsConfig = {
    "aws_project_region": "eu-north-1",
    "aws_cognito_identity_pool_id": "eu-north-1:769b07be-60d0-43d7-9310-c5c420c4845c",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_Jc8Dfqc0P",
    "aws_user_pools_web_client_id": "6nb9r8i5j6a0u8hsi7qgl55q0g",
    "aws_cognito_username_attributes": ["EMAIL"],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": ["EMAIL"],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": ["SMS"],
    "aws_cognito_password_protection_settings": {
      "passwordPolicyMinLength": 8,
      "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": ["EMAIL"],
    "aws_appsync_graphqlEndpoint": "https://3bsz3f3djzhbbc3qcvgauw4bxa.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
  };
}

// Configure Amplify globally
Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);